import { useEffect, useRef } from "react"
import { useIsAuthorizedUser } from "@hooks/useIsAuthorizedUser"
import { ym } from "@/utils/metrika"

// Отправляет в Метрику цель auth_success в момент входа/регистрации любым способом
// (почта, Google, VK, Яндекс). При загрузке уже авторизованного пользователя не срабатывает:
// статус берётся из хранилища сразу, перехода «нет → да» не происходит.
export function AuthSuccessTracker() {
  const isAuth = useIsAuthorizedUser()
  const prev = useRef(isAuth)
  useEffect(() => {
    if (!prev.current && isAuth) ym.authSuccess()
    prev.current = isAuth
  }, [isAuth])
  return null
}
export default AuthSuccessTracker
